import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Box, Typography, TextField, FormControl,
  RadioGroup, FormControlLabel, Button,
} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import '../TargetSearchComponent';
import { INDUSTRY_FLG, PATTERN_MATCH, TARGET_SEARCH_DISP_ITEM } from '../../../../common/const';
import {
  setCapitalFrom,
  setCapitalTo,
  setDispCapitalFrom,
  setDispCapitalTo,
  setEmployeeFrom,
  setEmployeeTo,
  setDispEmployeesFrom,
  setDispEmployeesTo,
  setRepLastName,
  setRepFirstName,
  setSgkn,
  setSgknSearchType,
  setStartYearFrom,
  setStartMonthFrom,
  setStartYearTo,
  setStartMonthTo,
  setMarketSegment,
  setSyrkGkny,
  setIndustryPopFlg,
  setProductsPopFlg,
  setIndustryAddCondition,
  setProductAddCondition,
  setAddressPopFlg,
  setMainIndustryFlg,
  setAddressAddCondition,
} from '../../../actions/TargetAction';
import styles from '../style.module.css';
import CustomCheckbox from '../../common/CustomCheckbox';
import CustomRadio from '../../common/CustomRadio';

class CompanyBasicInfomation extends Component {
  /**
   *所在地条件ポップアップを画面に表示する。
   */
  showAddressPop = () => {
    const {
      setAddressPopFlgAct,
      addressDisplayCondition,
      setAddressAddConditionAct,
    } = this.props;
    setAddressPopFlgAct(true);

    // 所在地選択ポップアップの選択内容一覧を設定
    setAddressAddConditionAct(addressDisplayCondition);
  };

  /**
   *業種選択ポップアップを画面に表示する。
   */
  showIndustryPop = () => {
    const {
      setIndustryPopFlgAct,
      industryDisplayCondition,
      setIndustryAddConditionAct,
    } = this.props;
    setIndustryPopFlgAct(true);

    // 業種選択ポップアップの選択内容一覧を設定
    setIndustryAddConditionAct(industryDisplayCondition);
  };

  /**
   *扱い品選択ポップアップを画面に表示する。
   */
  showProductsPop = () => {
    const {
      setProductsPopFlgAct,
      productDisplayCondition,
      setProductAddConditionAct,
    } = this.props;
    setProductsPopFlgAct(true);

    // 扱い品選択ポップアップの選択内容一覧を設定
    setProductAddConditionAct(productDisplayCondition);
  }

  /**
     *主業種フラグ変更
     */
  changeIndustryFlgCheck = () => {
    const { setMainIndustryFlgAct, mainIndustryFlg } = this.props;
    if (mainIndustryFlg === INDUSTRY_FLG.INDUSTRY_ONE) {
      setMainIndustryFlgAct(INDUSTRY_FLG.INDUSTRY_ALL);
    } else {
      setMainIndustryFlgAct(INDUSTRY_FLG.INDUSTRY_ONE);
    }
  };

  /**
   *上場市場チェックボックス変更
   */
  onChangeMarketSegmentCheckBox = (str) => {
    const { setMarketSegmentAct, marketSegment } = this.props;

    // 選択した市場区分を取得
    const selItem = str;
    // 上場市場リスト編集用の変数を宣言
    let newMarketSegment = [];

    if (marketSegment.indexOf(str) === -1) {
      // 選択した市場区分を上場市場リストに追加
      newMarketSegment.push(selItem);
      // 他に選択済の市場区分がある場合は上場市場リストに追加
      if (marketSegment && marketSegment.length > 0) {
        newMarketSegment = marketSegment.concat(newMarketSegment);
      }
    } else {
      // チェックOFFに変更した市場区分の配列位置を取得
      const delIndex = marketSegment.indexOf(selItem);
      // 配列位置が取得できた場合、該当の市場区分を削除
      if (delIndex >= 0) {
        newMarketSegment = marketSegment.concat(newMarketSegment);
        newMarketSegment.splice(delIndex, 1);
      }
    }
    setMarketSegmentAct(newMarketSegment);
  };

  render() {
    const {
      sgkn,
      setSgknAct,
      sgknSearchType,
      setSgknSearchTypeAct,
      errMsgSgkn,
      dispCapitalFrom,
      dispCapitalTo,
      setDispCapitalFromAct,
      setDispCapitalToAct,
      errMsgCapital,
      dispEmployeesFrom,
      dispEmployeesTo,
      setDispEmployeesFromAct,
      setDispEmployeesToAct,
      errMsgEmployees,
      startYearFrom,
      startMonthFrom,
      startYearTo,
      startMonthTo,
      errMsgStartYm,
      setStartYearFromAct,
      setStartMonthFromAct,
      setStartYearToAct,
      setStartMonthToAct,
      repLastName,
      repFirstName,
      setRepLastNameAct,
      setRepFirstNameAct,
      errMsgRepName,
      syrkGkny,
      setSyrkGknyAct,
      errMsgSyrkGkny,
      marketSegmentList,
      onBlurSgkn,
      onBlurCapital,
      onBlurEmployees,
      onBlurStartYm,
      onBlurRepName,
      onBlurSyrkGkny,
      marketSegment,
      checkErrFlg,
      industryCondition,
      productsCondition,
      addressCondition,
      mainIndustryFlg,
      targetingDispItems,
    } = this.props;

    // 概況の表示・非表示設定
    let dispFlg = false;
    if (targetingDispItems) {
      targetingDispItems.search_option_list.forEach((label) => {
        if (label.item_name === TARGET_SEARCH_DISP_ITEM.GAIKYO) {
          dispFlg = true;
        }
      });
    }

    // 現在日付取得
    const date = new Date();
    const currentYear = date.getFullYear().toString();
    const currentMonth = (date.getMonth() + 1).toString().padStart(2, '0');

    return (
      <Box className={`${styles.parts}`}>
        <Paper elevation={0} className={`${styles.sectionBox}`}>
          <Box className={`${styles.alignItemsCenter} ${styles.displayFlex} ${styles.marginBottomTitle}`}>
            <Box className={`${styles.sectionTitleIcon} ${styles.marginRightHalf}`} />
            <Typography variant="h6" component="div" className={`${styles.sectionTitle}`}>企業基本情報</Typography>
          </Box>
          <Box className={`${styles.searchTargetItemInterval}`}>
            <Box>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>商号漢字</Typography>
              <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder="xxxx"
                  InputProps={{ classes: { input: styles.inputSizingLarge } }}
                  value={sgkn || ''}
                  onChange={(ev) => setSgknAct(ev.target.value)}
                  onBlur={onBlurSgkn}
                  error={checkErrFlg.checkSgkn}
                />
                <Box className={`${styles.errorMsgAreaMargin}`}>
                  <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgSgkn}</Typography>
                </Box>
              </Box>
              <Box className={`${styles.marginTopHalf} ${styles.marginLeftHalf}`}>
                <FormControl component="fieldset">
                  <RadioGroup row>
                    <FormControlLabel
                      value={PATTERN_MATCH.EXACT}
                      control={<CustomRadio />}
                      label="完全一致"
                      checked={sgknSearchType === PATTERN_MATCH.EXACT}
                      onChange={() => setSgknSearchTypeAct(PATTERN_MATCH.EXACT)}
                    />
                    <FormControlLabel
                      value={PATTERN_MATCH.FORWARD}
                      control={<CustomRadio />}
                      label="前方一致"
                      checked={sgknSearchType === PATTERN_MATCH.FORWARD}
                      onChange={() => setSgknSearchTypeAct(PATTERN_MATCH.FORWARD)}
                      className={`${styles.marginLeft1}`}
                    />
                    <FormControlLabel
                      value={PATTERN_MATCH.BACKWARD}
                      control={<CustomRadio />}
                      label="後方一致"
                      checked={sgknSearchType === PATTERN_MATCH.BACKWARD}
                      onChange={() => setSgknSearchTypeAct(PATTERN_MATCH.BACKWARD)}
                      className={`${styles.marginLeft1}`}
                    />
                    <FormControlLabel
                      value={PATTERN_MATCH.PART}
                      control={<CustomRadio />}
                      label="部分一致"
                      checked={sgknSearchType === PATTERN_MATCH.PART}
                      onChange={() => setSgknSearchTypeAct(PATTERN_MATCH.PART)}
                      className={`${styles.marginLeft1}`}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
            <Box>
              <Box className={`${styles.displayFlex}`}>
                <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>所在地</Typography>
              </Box>
              <Box className={`${styles.marginTopHalf} ${styles.displayFlex}`}>
                <Button
                  variant="contained"
                  className="tertiary"
                  endIcon={<OpenInNewIcon />}
                  onClick={this.showAddressPop}
                >
                  所在地を選択する
                </Button>
                {addressCondition
                  && addressCondition.length > 0
                  && (
                    <Typography className={`${styles.countLabel}`} component="span">{`≫${addressCondition.length}件の条件を設定中`}</Typography>
                  )}
              </Box>
            </Box>
            <Box>
              <Box className={`${styles.displayFlex}`}>
                <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>業種</Typography>
              </Box>
              <Box className={`${styles.displayFlex} ${styles.marginTopHalf} `}>
                <Button
                  variant="contained"
                  className="tertiary"
                  endIcon={<OpenInNewIcon />}
                  onClick={this.showIndustryPop}
                >
                  業種を選択する
                </Button>
                <FormControlLabel
                  control={(
                    <CustomCheckbox
                      onClick={this.changeIndustryFlgCheck}
                      checked={mainIndustryFlg === INDUSTRY_FLG.INDUSTRY_ONE}
                    />
                  )}
                  label="主業種のみを検索"
                  className={`${styles.marginLeft1}`}
                />
                {industryCondition
                  && industryCondition.length > 0
                  && (
                    <Typography className={`${styles.countLabel}`} component="span">{`≫${industryCondition.length}件の条件を設定中`}</Typography>
                  )}
              </Box>
            </Box>
            <Box>
              <Box className={`${styles.displayFlex} `}>
                <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>扱い品</Typography>
              </Box>
              <Box className={`${styles.marginTopHalf} ${styles.displayFlex}`}>
                <Button
                  variant="contained"
                  className="tertiary"
                  endIcon={<OpenInNewIcon />}
                  onClick={this.showProductsPop}
                >
                  扱い品を選択する
                </Button>
                {productsCondition
                  && productsCondition.length > 0
                  && (
                    <Typography className={`${styles.countLabel}`} component="span">{`≫${productsCondition.length}件の条件を設定中`}</Typography>
                  )}
              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>資本金</Typography>
              <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder="0000"
                  value={dispCapitalFrom || ''}
                  onChange={(ev) => setDispCapitalFromAct(ev.target.value)}
                  onBlur={onBlurCapital}
                  error={checkErrFlg.checkCapitalFrom}
                  InputProps={{ classes: { input: styles.inputSizing } }}
                />
                <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>千円</Typography>
                <Box className={`${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                  <Typography variant="body2">～</Typography>
                </Box>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder="0000"
                  value={dispCapitalTo || ''}
                  onChange={(ev) => setDispCapitalToAct(ev.target.value)}
                  onBlur={onBlurCapital}
                  error={checkErrFlg.checkCapitalTo}
                  InputProps={{ classes: { input: styles.inputSizing } }}
                />
                <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>千円</Typography>
                <Box className={`${styles.errorMsgAreaMargin}`}>
                  <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgCapital}</Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>従業員数</Typography>
              <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder="0000"
                  value={dispEmployeesFrom || ''}
                  onChange={(ev) => setDispEmployeesFromAct(ev.target.value)}
                  onBlur={onBlurEmployees}
                  error={checkErrFlg.checkEmployeesFrom}
                  InputProps={{ classes: { input: styles.inputSizing } }}
                />
                <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>人　</Typography>
                <Box className={`${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                  <Typography variant="body2" component="span">～</Typography>
                </Box>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder="0000"
                  value={dispEmployeesTo || ''}
                  onChange={(ev) => setDispEmployeesToAct(ev.target.value)}
                  onBlur={onBlurEmployees}
                  error={checkErrFlg.checkEmployeesTo}
                  InputProps={{ classes: { input: styles.inputSizing } }}
                />
                <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>人</Typography>
                <Box className={`${styles.errorMsgAreaMargin}`}>
                  <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgEmployees}</Typography>
                </Box>

              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>設立年月日</Typography>
              <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder={currentYear}
                  value={startYearFrom || ''}
                  onChange={(ev) => setStartYearFromAct(ev.target.value)}
                  onBlur={onBlurStartYm}
                  error={checkErrFlg.checkStartYearFrom}
                  InputProps={{ classes: { input: styles.inputSizingMedium } }}
                />
                <Typography variant="body2" className={`${styles.marginRightHalf} ${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>年</Typography>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder={currentMonth}
                  value={startMonthFrom || ''}
                  onChange={(ev) => setStartMonthFromAct(ev.target.value)}
                  onBlur={onBlurStartYm}
                  error={checkErrFlg.checkStartMonthFrom}
                  InputProps={{ classes: { input: styles.inputSizingSmall } }}
                />
                <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>月</Typography>
                <Box className={`${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                  <Typography variant="body2">～</Typography>
                </Box>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder={currentYear}
                  value={startYearTo || ''}
                  onChange={(ev) => setStartYearToAct(ev.target.value)}
                  onBlur={onBlurStartYm}
                  error={checkErrFlg.checkStartYearTo}
                  InputProps={{ classes: { input: styles.inputSizingMedium } }}
                />
                <Typography variant="body2" className={`${styles.marginRightHalf} ${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>年</Typography>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder={currentMonth}
                  value={startMonthTo || ''}
                  onChange={(ev) => setStartMonthToAct(ev.target.value)}
                  onBlur={onBlurStartYm}
                  error={checkErrFlg.checkStartMonthTo}
                  InputProps={{ classes: { input: styles.inputSizingSmall } }}
                />
                <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>月</Typography>
                <Box className={`${styles.errorMsgAreaMargin}`}>
                  <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgStartYm}</Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>上場市場</Typography>
              <Box className={`${styles.marketSegmentCheckboxBlock}`}>
                {marketSegmentList && marketSegmentList.map((item, i) => (
                  <Box key={i} className={`${styles.marketSegmentCheckbox} ${styles.marginLeftHalf}`}>
                    <FormControlLabel
                      control={(
                        <CustomCheckbox
                          checked={marketSegment && marketSegment.indexOf(item.cdshbtch) >= 0}
                          onChange={() => this.onChangeMarketSegmentCheckBox(item.cdshbtch)}
                        />
                      )}
                      label={item.cdch_im}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>代表者名</Typography>
              <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder="姓"
                  value={repLastName || ''}
                  onChange={(ev) => setRepLastNameAct(ev.target.value)}
                  onBlur={onBlurRepName}
                  error={checkErrFlg.checkRepLastName}
                  InputProps={{ classes: { input: styles.inputSizing } }}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  placeholder="名"
                  className={`${styles.marginLeft2}`}
                  value={repFirstName || ''}
                  onChange={(ev) => setRepFirstNameAct(ev.target.value)}
                  onBlur={onBlurRepName}
                  error={checkErrFlg.checkRepFirstName}
                  InputProps={{ classes: { input: styles.inputSizing } }}
                />
                <Box className={`${styles.errorMsgAreaMargin}`}>
                  <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgRepName}</Typography>
                </Box>
              </Box>
            </Box>
            {dispFlg && (
              <Box className={`${styles.positionRelative}`}>
                <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>概況</Typography>
                <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    placeholder="検索キーワード"
                    value={syrkGkny || ''}
                    onChange={(ev) => setSyrkGknyAct(ev.target.value)}
                    onBlur={onBlurSyrkGkny}
                    error={checkErrFlg.checkSyrkGkny}
                    InputProps={{ classes: { input: styles.inputSizing } }}
                  />
                  <Box className={`${styles.errorMsgAreaMargin}`}>
                    <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgSyrkGkny}</Typography>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    sgkn: state.target.sgkn,
    sgknSearchType: state.target.sgknSearchType,
    errMsgSgkn: state.target.errMsgSgkn,
    startYearFrom: state.target.startYearFrom,
    startMonthFrom: state.target.startMonthFrom,
    startYearTo: state.target.startYearTo,
    startMonthTo: state.target.startMonthTo,
    errMsgStartYm: state.target.errMsgStartYm,
    margetSegment: state.target.margetSegment,
    syrkGkny: state.target.syrkGkny,
    errMsgSyrkGkny: state.target.errMsgSyrkGkny,
    capitalFrom: state.target.capitalFrom,
    capitalTo: state.target.capitalTo,
    dispCapitalFrom: state.target.dispCapitalFrom,
    dispCapitalTo: state.target.dispCapitalTo,
    errMsgCapital: state.target.errMsgCapital,
    employeeFrom: state.target.employeeFrom,
    employeeTo: state.target.employeeTo,
    dispEmployeesFrom: state.target.dispEmployeesFrom,
    dispEmployeesTo: state.target.dispEmployeesTo,
    errMsgEmployees: state.target.errMsgEmployees,
    repLastName: state.target.repLastName,
    repFirstName: state.target.repFirstName,
    errMsgRepName: state.target.errMsgRepName,
    marketSegmentList: state.target.marketSegmentList,
    marketSegment: state.target.marketSegment,
    addressDisplayCondition: state.target.addressDisplayCondition,
    industryDisplayCondition: state.target.industryDisplayCondition,
    productDisplayCondition: state.target.productDisplayCondition,
    mainIndustryFlg: state.target.mainIndustryFlg,
    checkErrFlg: state.target.checkErrFlg,
    industryCondition: state.target.industryCondition,
    productsCondition: state.target.productsCondition,
    addressCondition: state.target.addressCondition,
    targetingDispItems: state.target.targetingDispItems,
  }),
  (dispatch) => ({
    setSgknAct: (str) => dispatch(setSgkn(str)),
    setSgknSearchTypeAct: (str) => dispatch(setSgknSearchType(str)),
    setStartYearFromAct: (str) => dispatch(setStartYearFrom(str)),
    setStartMonthFromAct: (str) => dispatch(setStartMonthFrom(str)),
    setStartYearToAct: (str) => dispatch(setStartYearTo(str)),
    setStartMonthToAct: (str) => dispatch(setStartMonthTo(str)),
    setMarketSegmentAct: (str) => dispatch(setMarketSegment(str)),
    setSyrkGknyAct: (str) => dispatch(setSyrkGkny(str)),
    setCapitalFromAct: (str) => dispatch(setCapitalFrom(str)),
    setCapitalToAct: (str) => dispatch(setCapitalTo(str)),
    setDispCapitalFromAct: (str) => dispatch(setDispCapitalFrom(str)),
    setDispCapitalToAct: (str) => dispatch(setDispCapitalTo(str)),
    setEmployeeFromAct: (str) => dispatch(setEmployeeFrom(str)),
    setEmployeeToAct: (str) => dispatch(setEmployeeTo(str)),
    setDispEmployeesFromAct: (str) => dispatch(setDispEmployeesFrom(str)),
    setDispEmployeesToAct: (str) => dispatch(setDispEmployeesTo(str)),
    setRepLastNameAct: (str) => dispatch(setRepLastName(str)),
    setRepFirstNameAct: (str) => dispatch(setRepFirstName(str)),
    setIndustryPopFlgAct: (bool) => dispatch(setIndustryPopFlg(bool)),
    setProductsPopFlgAct: (bool) => dispatch(setProductsPopFlg(bool)),
    setIndustryAddConditionAct: (obj) => dispatch(setIndustryAddCondition(obj)),
    setProductAddConditionAct: (obj) => dispatch(setProductAddCondition(obj)),
    setAddressPopFlgAct: (bool) => dispatch(setAddressPopFlg(bool)),
    setMainIndustryFlgAct: (str) => dispatch(setMainIndustryFlg(str)),
    setAddressAddConditionAct: (obj) => dispatch(setAddressAddCondition(obj)),

  }),
)(CompanyBasicInfomation);
